export interface BoqFilter {
	filterEnvironment?: string;
	filterSubLocation1?: string;
	filterSubLocation2?: string;
	filterSubLocation3?: string;
}
